// The generated schemas are frozen at module load: a runtime-written `initial` makes every preset read permanently dirty.
export const deepFreeze = value => {
	if (value === null || typeof value !== 'object' || Object.isFrozen(value)) return value
	Object.freeze(value)
	for (const key of Object.keys(value)) deepFreeze(value[key])
	return value
}

export default deepFreeze
